import React, { useEffect, useState } from "react";
import ImageWithBasePath from "../../core/common/imageWithBasePath";
import { all_routes } from "../router/all_routes";
import { loginUser } from "../../api/api";
import {  useNavigate } from "react-router-dom";

import { getUserPrivilegeByUsername } from "../../api/api";
import { usePrivileges } from "../../core/context/PrivilegeContext";
import { useSocket } from "../../core/context/SocketContext";
import { checkDbStatus } from "../../api/api";
 

const Login = () => {
  const route = all_routes;
  const navigate = useNavigate();

   const { setPrivileges } = usePrivileges(); // GET CONTEXT FUNCTION
   const { connectSocket } = useSocket();

  const [email, setEmail] = useState("");
  const [clientCode, setClientCode] = useState("");
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setPasswordVisible] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); //loader

  const togglePasswordVisibility = () => {
    setPasswordVisible((prevState) => !prevState);
  };

  useEffect(() => {
    localStorage.setItem("menuOpened", "Dashboard");
  }, []);

  //the handlesubmit is updated for the condition if any table is missing redirecting to db updates. if the tables exsists redirect to leadsdashboard on apr/10/26. also the privileges is set to empty array if the data.privileges is not an array to avoid any error in the sidebar when checking for privileges. the getUserPrivilegeByUsername is removed from the handlesubmit because now the privileges are sent from the backend in the login response and there is no need to make another api call to get the privileges.
 const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault(); //prevent page reload

    setLoading(true); //START LOADER

  try {
    //  LOGIN
    const data = await loginUser(email, password, clientCode);
    console.log("USERNAME FROM API:", data.username);
    //  STORE TOKEN + CLIENT ID
    localStorage.setItem("token", data.token);
    localStorage.setItem("clientId", data.clientId);
    localStorage.setItem("username", data.username);
    console.log("LOGIN SUCCESS:", data);

    // 🔌 CONNECT SOCKET (if using)
    connectSocket(data.token);

    // CHECK DB STATUS
    const dbStatus = await checkDbStatus();
    console.log("DB STATUS:", dbStatus);

    if (dbStatus.status === "MISSING") {
      console.log("Missing tables:", dbStatus.missingTables);

      //redirect to DB updates page
      navigate(route.dbUpdates);
      return;
    }

    //GET USER PRIVILEGES
    setPrivileges( Array.isArray(data.privileges) ? data.privileges : [] ); // ensure privileges is always an array on apr/10/26.the handlesubmit is updated for the condition if any table is missing redirecting to db updates. if the tables exsists redirect to leadsdashboard

    //NAVIGATE TO LEADS DASHBOARD
    navigate(route.leadsDashboard);

  } catch (error: any) {
    console.error("Login error:", error);
    setError(error?.response?.data?.error || "Login failed");

    setLoading(false); //  only stop on error
  }
};


  return (
     <>
      {loading && <Preloader />} 
    <div className="account-content">
      <div className="d-flex flex-wrap w-100 vh-100 overflow-hidden account-bg-01">
        <div className="d-flex align-items-center justify-content-center flex-wrap vh-100 overflow-auto p-4 w-100 bg-backdrop">
          <form className="flex-fill" onSubmit={handleSubmit}>
            <div className="mx-auto mw-450">
              <div className="text-center mb-4">
                <ImageWithBasePath
                  src="assets/img/wizzo-small.png"
                  className="img-fluid"
                  alt="Logo"
                />
              </div>
              <div className="mb-4">
                <h4>Sign In</h4>
                <p>Access the CRM panel using your email and passcode.</p>
              </div>

              {/* Error Message */}
              {error && (
                <div className="alert alert-danger text-center">{error}</div>
              )}

                {/* client code */}
              <div className="mb-3">
                <label className="col-form-label">Client Code</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-user"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={clientCode}
                    onChange={(e) => setClientCode(e.target.value)} 
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="col-form-label">Email Address</label>
                <div className="position-relative">
                  <span className="input-icon-addon">
                    <i className="ti ti-mail"></i>
                  </span>
                  <input
                    type="text"
                    className="form-control"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              </div>

              <div className="mb-3">
                <label className="col-form-label">Password</label>
                <div className="pass-group">
                  <input
                    type={isPasswordVisible ? "text" : "password"}
                    className="pass-input form-control"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <span
                    className={`ti toggle-password ${
                      isPasswordVisible ? "ti-eye" : "ti-eye-off"
                    }`}
                    onClick={togglePasswordVisibility}
                  ></span>
                </div>
              </div>

              

              <div className="d-flex align-items-center justify-content-between mb-3">
                {/* <div className="form-check form-check-md d-flex align-items-center">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="checkebox-md"
                    defaultChecked
                  />
                  <label className="form-check-label" htmlFor="checkebox-md">
                    Remember Me
                  </label>
                </div> */}
                {/* <div className="text-end">
                  <Link
                    to={route.forgotPassword}
                    className="text-primary fw-medium link-hover"
                  >
                    Forgot Password?
                  </Link>
                </div> */}
              </div>

              <div className="mb-3">
               <button type="submit" className="btn btn-primary w-100" disabled={loading}>
  {loading ? "Signing in..." : "Sign In"}
</button>
              </div>

              {/* <div className="mb-3">
                <h6>
                  New on our platform?
                  <Link to={route.register} className="text-purple link-hover">
                    {" "}
                    Create an account
                  </Link>
                </h6>
              </div> */}

              {/* <div className="form-set-login or-text mb-3">
                <h4>OR</h4>
              </div> */}

              <>
                {/* <div className="d-flex align-items-center justify-content-center flex-wrap mb-3">
                  <div className="text-center me-2 flex-fill">
                    <Link
                      to="#"
                      className="br-10 p-2 px-4 btn bg-pending d-flex align-items-center justify-content-center"
                    >
                      <ImageWithBasePath
                        className="img-fluid m-1"
                        src="assets/img/icons/facebook-logo.svg"
                        alt="Facebook"
                      />
                    </Link>
                  </div>
                  <div className="text-center me-2 flex-fill">
                    <Link
                      to="#"
                      className="br-10 p-2 px-4 btn bg-white d-flex align-items-center justify-content-center"
                    >
                      <ImageWithBasePath
                        className="img-fluid m-1"
                        src="assets/img/icons/google-logo.svg"
                        alt="Google"
                      />
                    </Link>
                  </div>
                  <div className="text-center flex-fill">
                    <Link
                      to="#"
                      className="bg-dark br-10 p-2 px-4 btn btn-dark d-flex align-items-center justify-content-center"
                    >
                      <ImageWithBasePath
                        className="img-fluid m-1"
                        src="assets/img/icons/apple-logo.svg"
                        alt="Apple"
                      />
                    </Link>
                  </div>
                </div> */}

                <div className="text-center">
                  <p className="fw-medium text-gray">Copyright © 2025 - CRMS</p>
                </div>
              </>
            </div>
          </form>
        </div>
      </div>
    </div>
    </>
  );
};
const Preloader = () => {
  return (
    <div className="preloader">
      <div className="preloader">
        <div className="loader"></div>
      </div>
    </div>
  );
};
export default Login;
